package music.jammers.client.shared.profile.di

import music.jammers.client.shared.profile.domain.SaveNewUserProfileDataCase
import music.jammers.client.shared.profile.domain.ValidateProfileUseCase
import music.jammers.client.shared.profile.presentation.ui.ProfileFieldValidator
import music.jammers.client.shared.profile.presentation.viewmodel.ProfileViewModel
import org.koin.core.component.KoinComponent
import org.koin.dsl.module

val profileModule = module {

    factory {
        ProfileViewModel(
            router = get(),
            eventAnalytics = get(),
            getUserUseCase = get(),
            getCurrentUserUseCase = get(),
            saveNewUserProfileDataCase = get(),
            profileFieldValidator = get(),
            validateProfileUseCase = get(),
            logoutUseCase = get(),
        )
    }

    single<SaveNewUserProfileDataCase> {
        SaveNewUserProfileDataCase(
            userRepository = get()
        )
    }

    single {
        ProfileFieldValidator()
    }

    single {
        ValidateProfileUseCase(
            profileFieldValidator = get()
        )
    }
}

object ProfileComponent : KoinComponent {

    val profileViewModel: ProfileViewModel
        get() = getKoin().get<ProfileViewModel>()
}